import { useContext, useEffect } from 'react';
import { HookFormContext } from 'components/cef_form/hook-form/providers/HookFormProvider';
import MetaHelmet from 'helpers/MetaHelmet';
import ContactDetails from './ContactDetails';
import StepTemplate from '../StepTemplate';

const Step4 = () => {
  const {
    setCurrentStep,
    watchedFields: { companyType },
  } = useContext(HookFormContext);

  useEffect(() => {
    setCurrentStep(4);
  }, []);

  // ROUTE SETUP
  const mainRoute = <ContactDetails />;
  const soleTraderRoute = <ContactDetails soleTrader />;

  const companyComponents = {
    0: mainRoute, // LC
    1: soleTraderRoute, // Sole Trader
    5: mainRoute, // LLP
    6: mainRoute, // PLC
  };

  return (
    <>
      <MetaHelmet />
      <StepTemplate step={3}>{companyComponents[companyType]}</StepTemplate>
    </>
  );
};

export default Step4;
